<div class="container-fluid">
  <header>
    <app-nav-menu></app-nav-menu>
  </header>

  <main role="main" class="backg">
    <div class="container-fluid ">
      <div class="row">
        <div class="col-sm-12 col-md-6 left_content">
          <div class="left_con">
            <h2 class=" welcome1message">Welcome to PATEMPO!</h2>
            <p class="mt-4 text-left text-secondary welcome2message">PATEMPO™ responds to a critical question that any patent applicant or agent has: “Assuming I can obtain a patent, how long will it take to get granted?”. It allows to automatically estimate the pendency of your patent applications in China and South-East Asia and to instantly access to our recommendations on how to expedite their examination, publication and grant.</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 right_content">
          <div class="right_con">
            <form [formGroup]="formModel" autocomplete="off" (submit)="onSubmit()">
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin-clockwise-fade" [fullScreen]="false"></ngx-spinner>
              <div class="row">
                <div class="col-12 text-left ">
                  <h3 class="text-secondary password-resetTitle"><strong>Password Reset</strong></h3>
                </div>
              </div>
              <div formGroupName="Passwords">
                <div class="row px-3 mb-3 mt-4">
                  <label class="mb-0"><h6 class="text-sm">New Password</h6></label>
                  <input type="password" class="newpassword" formControlName="Password" autocomplete="off" [disabled]="isdisabled" placeholder="Password">
                  <label class="text-danger" *ngIf="formModel.get('Passwords.Password').touched && formModel.get('Passwords.Password').errors?.required">
                    <i>required</i>
                  </label>
                  <label class="text-danger" *ngIf="formModel.get('Passwords.Password').touched && formModel.get('Passwords.Password').errors?.minlength">
                    <i> Minimum 8 characters required.</i>
                  </label>
                </div>
                <div class="row px-3">
                  <label class="mb-0"><h6 class="text-sm">Confirm Password</h6></label>
                  <input type="password" class="confirmPassword" formControlName="ConfirmPassword" autocomplete="off" [disabled]="isdisabled" placeholder="Confirm Password">
                  <label class="text-danger" *ngIf="formModel.get('Passwords.ConfirmPassword').touched && formModel.get('Passwords.ConfirmPassword').errors?.required">
                    <i>required</i>
                  </label>
                  <label class="text-danger" *ngIf="formModel.get('Passwords.ConfirmPassword').touched && formModel.get('Passwords.ConfirmPassword').errors?.passwordMismatch">
                    <i>Confirm Password does not match.</i>
                  </label>
                </div>
              </div>
              <div class="row px-3 mb-3">

              </div>
              <div class="row mb-3 px-3 mt-4"> <button type="submit" class="text-center w-100 btn-login text-white reset-button" [disabled]="!formModel.valid">Reset Password</button> </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <div class="LoginFooter">
    <footer>
      <patempoFooter></patempoFooter>
    </footer>
  </div>
</div>



